<script lang="ts">
import { type Snippet } from 'svelte'

import { linkOpenEvent } from '@/modules/linkPreview'

type Props = {
	children?: Snippet
	shouldSendLinkOpenedEvent?: boolean
}
let { children, shouldSendLinkOpenedEvent = false }: Props = $props()
</script>

<div class="message-content-html whitespace-normal flex flex-col gap-3" use:linkOpenEvent={shouldSendLinkOpenedEvent}>
	{@render children?.()}
</div>

<style lang="postcss">
:global(.message-content-html ul) {
	@apply list-disc pl-4 mr-1;
}

:global(.message-content-html li:not(:first-child)) {
	@apply mt-2;
}

:global(.message-content-html li > ul),
:global(.message-content-html li > ol) {
	@apply mt-2;
}

:global(.message-content-html ol) {
	@apply list-decimal pl-4 mr-1;
}

:global(.message-content-html a) {
	@apply underline hover-no-underline;
}

:global(.message-content-html *) {
	@apply whitespace-normal break-words;
}
</style>
